const NON_PROD_ENVIRONMENTS_NAMES = ['SBX', 'ADT', 'QAT', 'UAT', 'SPT'];
const PROD_ENVIRONMENTS_NAMES = ['STG', 'PRD'];

export default {
  NON_PROD_ENVIRONMENTS_NAMES,
  PROD_ENVIRONMENTS_NAMES,
};
